import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

function buildPages(total, current) {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages = new Set([1, total, current, current - 1, current + 1]);
  if (current <= 3) [2, 3, 4].forEach((n) => pages.add(n));
  if (current >= total - 2) [total - 1, total - 2, total - 3].forEach((n) => pages.add(n));
  const arr = [...pages].filter((n) => n >= 1 && n <= total).sort((a, b) => a - b);
  const out = [];
  for (let i = 0; i < arr.length; i++) {
    if (i > 0 && arr[i] - arr[i - 1] > 1) out.push("…");
    out.push(arr[i]);
  }
  return out;
}

export default function ListPager({
  currentPage,
  totalPages,
  onChange,
  rangeLabel,
  prevLabel = "Faqja e mëparshme",
  nextLabel = "Faqja tjetër",
}) {
  if (!totalPages || totalPages < 1) return null;
  const pages = buildPages(totalPages, currentPage);

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 pt-2">
      {rangeLabel ? (
        <p className="text-xs sm:text-sm text-gray-500">{rangeLabel}</p>
      ) : (
        <span />
      )}
      <div className="inline-flex items-center gap-1">
        <button
          type="button"
          disabled={currentPage <= 1}
          onClick={() => onChange(currentPage - 1)}
          className="inline-flex items-center justify-center h-9 w-9 rounded-lg border border-gray-200 bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition"
          aria-label={prevLabel}
        >
          <FiChevronLeft size={16} />
        </button>
        {pages.map((p, i) =>
          p === "…" ? (
            <span key={`e${i}`} className="px-2 text-gray-400 select-none">
              …
            </span>
          ) : (
            <button
              key={p}
              type="button"
              onClick={() => onChange(p)}
              className={`min-w-9 h-9 px-3 rounded-lg text-sm font-semibold transition ${
                p === currentPage
                  ? "bg-[var(--secondary-color)] text-white shadow-sm"
                  : "bg-white text-gray-700 border border-gray-200 hover:bg-gray-50"
              }`}
            >
              {p}
            </button>
          )
        )}
        <button
          type="button"
          disabled={currentPage >= totalPages}
          onClick={() => onChange(currentPage + 1)}
          className="inline-flex items-center justify-center h-9 w-9 rounded-lg border border-gray-200 bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition"
          aria-label={nextLabel}
        >
          <FiChevronRight size={16} />
        </button>
      </div>
    </div>
  );
}
